<template>
  <li :class="getClassObject" :tab-index="tabIndex">
    <router-link :to="{ name: routeName}">{{ routeLabel }}</router-link>
    <navigation-item v-for="child in children"
                     :key="child.routeName"
                     :route-name="child.routeName"
                     :route-label="child.routeLabel"/>
  </li>
</template>

<script>
export default {
  name: 'NavigationItem',
  props: {
    routeName: {
      type: String,
      required: true
    },
    routeLabel: {
      type: String,
      required: true
    },
    customClass: {
      type: String,
      required: false,
      default: ''
    },
    tabIndex: {
      type: String,
      required: false,
      default: ''
    },
    children: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    getClassObject () {
      const classObject = {
        current: this.$store.state.route.name === this.routeName
      }
      if (this.customClass) {
        classObject[this.customClass] = true
      }
      return classObject
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NavigationItem.vue